var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDirectionDown(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "direaction down"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Combo shape",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.414376 10.5315C0.155619 10.8549 0.20806 11.3269 0.531506 11.5856C0.854953 11.8444 1.32692 11.7919 1.58568 11.4685L5.58568 6.46849C5.80481 6.19458 5.80481 5.80536 5.58568 5.53145L1.58568 0.531451C1.32692 0.208005 0.854952 0.155563 0.531506 0.414321C0.208059 0.673078 0.155618 1.14505 0.414376 1.46849L4.03956 5.99997L0.414376 10.5315ZM6.41438 10.5315C6.15562 10.8549 6.20806 11.3269 6.53151 11.5856C6.85495 11.8444 7.32692 11.7919 7.58568 11.4685L11.5857 6.46849C11.8048 6.19458 11.8048 5.80536 11.5857 5.53145L7.58568 0.531451C7.32692 0.208005 6.85495 0.155563 6.53151 0.414321C6.20806 0.673077 6.15562 1.14505 6.41438 1.46849L10.0396 5.99997L6.41438 10.5315Z",
    fill: "#DE8D8D"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDirectionDown);
export default __webpack_public_path__ + "static/media/direction-down.0159dbf8a8e752cc474ca08d8f13aa41.svg";
export { ForwardRef as ReactComponent };